import { EditButton, Show, useForm } from "@refinedev/antd";
import {
  dateFormat,
  DayMonthYearHoursAndMinutes,
  disablePreviousDates,
  errorNotification,
  hoursAndMinutes,
  successNotification,
} from "../../../helpers";

import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Tag,
} from "antd";
import { AppImageUploader, AppTitle, EFileTypes } from "../../../components";
import { v4 as randomId } from "uuid";
import { NewsBlockCreate } from "../News-Create/News-Block-Create";
import { NewCreateHashTags } from "../News-Create/New-Create-Hash-Tags";
import { useMatch } from "react-router-dom";
import { NewsCreateRequest } from "../Lib/types";
import { NewsDelete } from "../News-Delete/News-Delete";
import { useWatch } from "antd/es/form/Form";
import { useMemo } from "react";
import dayjs from "dayjs";

export const NewsShow = () => {
  const route = useMatch("/:parent/:action/:id");
  const id = route?.params.id;

  const { formProps, saveButtonProps, form, formLoading } =
    useForm<NewsCreateRequest>({
      resource: "news",
      action: "edit",
      id,
      dataProviderName: "newsDataProvider",
      redirect: false,
      ...successNotification({
        successData: {
          message: "Размещение успешно создано",
          type: "success",
        },
      }),
      ...errorNotification({
        errorData: {
          errorKeys: [
            {
              errorCode: "channelPoints.invalid",
              message:
                "Невозможно добавить баллы без создания маркетингового канала",
            },
          ],
        },
      }),
    });

  const watchReleaseDate = useWatch("newsDate", form);
  const isPublic = useWatch("isPublic", form);

  const renderDate = useMemo(() => {
    if (watchReleaseDate === "Invalid Date") {
      return dateFormat();
    }
    return dateFormat(watchReleaseDate, DayMonthYearHoursAndMinutes);
  }, [watchReleaseDate]);

  return (
    <Show
      isLoading={formLoading}
      title={
        <AppTitle isLoading={formLoading} canGoBack>
          Просмотр новости
          <Tag color={!formProps.initialValues?.isPublic ? "orange" : "blue"}>
            {!formProps.initialValues?.isPublic ? "Черновик" : "Публикация"}
          </Tag>
        </AppTitle>
      }
      breadcrumb={false}
      headerButtons={
        <Space direction={"horizontal"}>
          <EditButton id={id}>Редактировать</EditButton>
          <NewsDelete
            type={"page"}
            id={formProps.initialValues?.id}
            title={formProps.initialValues?.title}
          />
        </Space>
      }
      footerButtons={null}
      goBack={false}
    >
      <Form
        {...formProps}
        initialValues={{
          newsDate: dayjs(),
          ...formProps.initialValues,
          leagueId:
            formProps.initialValues?.leagueId === null
              ? 0
              : formProps.initialValues?.leagueId,
        }}
        layout={"vertical"}
      >
        <Row gutter={24}>
          <Col span={12}>
            <Space size={16} direction="vertical" style={{ width: "100%" }}>
              <Form.Item
                name={"mainPhotoUrl"}
                label={"Изображение новости"}
                rules={
                  [
                    // {
                    //   required: true,
                    //   message: "Укажите изображение",
                    // },
                  ]
                }
              >
                <AppImageUploader
                  type="NEWS"
                  disabled
                  entityId={`${randomId()}`}
                  serviceType={EFileTypes.NEWS}
                  cropperProps={{
                    modalTitle: "Редактировать изображение",
                  }}
                  uploadProps={{
                    multiple: false,
                    children: "Изображение новости",
                    listType: "picture-card",
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Заголовок"
                rules={[
                  { required: true, message: "Укажите заголовок" },
                  {
                    min: 5,
                    max: 100,
                    message: "Заголовок может быть от 5 до 100 символов",
                  },
                ]}
                name={"title"}
              >
                <Input.TextArea
                  disabled
                  rows={2}
                  placeholder={"Укажите заголовок"}
                />
              </Form.Item>
              <Form.Item
                label="Превью новости"
                rules={[
                  // { required: true, message: "Укажите превью" },
                  {
                    min: 5,
                    max: 1000,
                    message: "Описание может быть от 5 до 1000 символов",
                  },
                ]}
                name={"preview"}
              >
                <Input.TextArea
                  disabled
                  rows={2}
                  placeholder={"Укажите заголовок"}
                />
              </Form.Item>
              <NewsBlockCreate
                setDisabled={true}
                form={form}
                isPublic={isPublic}
              />
              <Form.Item
                name="leagueId"
                label={"Лига"}
                rules={[{ required: true, message: "Укажите лигу" }]}
              >
                <Select showArrow={true} placeholder="Выберите лигу" disabled>
                  <Select.Option key={"100"} value={100}>
                    Первая лига
                  </Select.Option>
                  <Select.Option key={"200"} value={200}>
                    Вторая лига А
                  </Select.Option>
                  <Select.Option key={"300"} value={300}>
                    Вторая лига Б
                  </Select.Option>
                  <Select.Option key={"0"} value={0}>
                    Все
                  </Select.Option>
                </Select>
              </Form.Item>
              <NewCreateHashTags disabled />
              <Form.Item name={"newsDate"} label={"Дата публикации"}>
                <DatePicker
                  allowClear={false}
                  disabled
                  format={DayMonthYearHoursAndMinutes}
                  disabledDate={disablePreviousDates}
                  showTime={{ format: hoursAndMinutes }}
                  style={{ width: "100%" }}
                  placeholder={"Укажите дату"}
                />
              </Form.Item>
              <Space
                direction={"horizontal"}
                align={"baseline"}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Form.Item name={"showDate"} valuePropName="checked">
                  <Checkbox disabled>Отображать дату публикации</Checkbox>
                </Form.Item>
                <div>Дата публикации: {renderDate}</div>
              </Space>
              <Form.Item
                name={"openForFnl"}
                getValueProps={(value) => ({ checked: value === false })}
              >
                <Checkbox disabled>Скрыть с сайта</Checkbox>
              </Form.Item>
              <Form.Item name={"transfer"} valuePropName="checked">
                <Checkbox disabled>ТрансферХаб</Checkbox>
              </Form.Item>
              <Form.Item name={"isPublic"} label={"Отредактировать как:"}>
                <Radio.Group disabled>
                  <Radio value={false}>Черновик</Radio>
                  <Radio value={true}>Публикацию</Radio>
                </Radio.Group>
              </Form.Item>
            </Space>
          </Col>
        </Row>
      </Form>
    </Show>
  );
};
